import React, { useMemo, useState } from 'react'
import { get } from 'lodash'
import ProductCard from './ProductCard'
import ScrollContainer from 'react-indiana-drag-scroll'
import PdpRequestSample from './PdpRequestSample'
// import LazyLoad from 'react-lazyload'
// import { RichText } from 'prismic-reactjs'
// import { linkResolver } from '@prismicio/gatsby-source-prismic-graphql'

const RelatedProducts = ({ data, index, products }) => {

  // console.log('[RelatedProducts.js] data', data)
  // console.log('[RelatedProducts.js] products', products)

  const auto_custom = useMemo(() => (
    get(data, 'primary.products')
  ), [data])

  const title = useMemo(() => (
    get(data, 'primary.title1[0].text', 'Related Products')
  ), [data])

  const custom_products = useMemo(() => (
    get(data, 'fields')
  ), [data])

  // Toggle Sample Form State

  const [sampleFormState, setSampleFormState] = useState('')
  const toggleSampleForm = () => {
    // setSortButtonState(!sortButtonState)
    if(sampleFormState === '') {
      setSampleFormState(' open')
    } else {
      setSampleFormState('')
    }
  }

  // console.log('custom_products', custom_products)

  return(
    <>
      <section
        key={index}
        className={"related_products"}>
        <div className="related_products__header">
          <div className="row">
            <div className="col col12">
              <h3 className="related_products__title">
                {title}
              </h3>
            </div>
          </div>
        
        </div>

        <div className="related_products__slider">

        <ScrollContainer
            className="scroll-container"
            hideScrollbars={false}>

            <div className="related_products__container">
              
            {auto_custom === "Auto" ?
              products && products.map((item, index) => (
                <ProductCard item={item} index={index} key={index} toggleSampleForm={toggleSampleForm} />
              ))
            : 
              custom_products && custom_products?.map((item, index) => (
                <ProductCard item={item} index={index} key={index} toggleSampleForm={toggleSampleForm} />
              ))
            }

            </div>
          </ScrollContainer>
        </div>
        
      </section>

      <PdpRequestSample
        state={sampleFormState}
        toggleSampleForm={toggleSampleForm} />
    </>
  )  
}

export default RelatedProducts
